/*globals React, ReactDOM */
import React from 'react';
import ReactDOM from 'react-dom';
import { SearchPage } from '../containers/SearchPage/SearchPage';

ReactDOM.render(<SearchPage pageSize="25"/>, document.getElementById('content'));


// WEBPACK FOOTER //
// ./index.js